import { createSlice } from "@reduxjs/toolkit";
import { getSupportKnowledge, askSupport } from "./supportApi";

const initialState = {
    faults: [],
    codes: [],
    aiEnabled: false,
    knowledgeStatus: "idle",
    messages: [],
    askStatus: "idle",
};

export const supportSlice = createSlice({
    name: "support",
    initialState,
    reducers: {
        addMessage: (state, action) => {
            state.messages.push(action.payload);
        },
        resetSupport: (state) => {
            state.messages = [];
            state.askStatus = "idle";
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(getSupportKnowledge.pending, (state) => {
                state.knowledgeStatus = "loading";
            })
            .addCase(getSupportKnowledge.fulfilled, (state, action) => {
                state.knowledgeStatus = "succeeded";
                state.faults = action.payload.faults;
                state.codes = action.payload.codes;
                state.aiEnabled = action.payload.ai_enabled;
            })
            .addCase(getSupportKnowledge.rejected, (state) => {
                state.knowledgeStatus = "failed";
            })
            .addCase(askSupport.pending, (state) => {
                state.askStatus = "loading";
            })
            .addCase(askSupport.fulfilled, (state) => {
                state.askStatus = "succeeded";
            })
            .addCase(askSupport.rejected, (state) => {
                state.askStatus = "failed";
            });
    },
});

export const { addMessage, resetSupport } = supportSlice.actions;
export default supportSlice.reducer;
